export default __webpack_public_path__ + "static/media/hot_bg3.a497f300.jpg";